module.exports = __webpack_public_path__ + "img/CARAC1.38c85c4e.jpg";